import { Injectable, Inject } from '@angular/core';
import { Office } from '../models/missingdata.model';
import { OfficeManagement, UserManagement } from '../models/management.model';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class OfficeService {


  private Url: string;
  private missingOffices: BehaviorSubject<Office[]>;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.Url = baseUrl;
    this.missingOffices = new BehaviorSubject<Office[]>(JSON.parse(localStorage.getItem('missingOffices')));
  }

  public get missingOfficesList(): Office[] {
    return this.missingOffices.value;
  }

  setOffices(Offices: Office[]) {
    localStorage.setItem('missingOffices', JSON.stringify(Offices));
  }

  getOffices() {
    return this.http.get<Office[]>(this.Url + 'api/offices/')
  }

  saveOffices(Offices: Office[]) {
    console.log(Offices);
    return this.http.post(this.Url + 'api/offices/', Offices)
  }


  getOfficeManagement() {
    return this.http.get<OfficeManagement[]>(this.Url + 'api/management')
  }


  saveOfficeManagement(users: UserManagement[]) {
    return this.http.post(this.Url + 'api/management',users)
  }

  updateOffice(office: Office) {
    return this.http.patch(this.Url + 'api/offices', office)
  }

}
